import React, { useState } from 'react';
import './Navbar.css';

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="container">
       
          <img src="/assets/logo.svg" alt="Dhrey Advisors" className="logo" />

        {/* Hamburger */}
        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <ul className={`nav-menu ${open ? 'active' : ''}`}>
          <li>
            <a href="#home" onClick={() => setOpen(false)}>Home</a>
          </li>
          <li>
            <a href="#services" onClick={() => setOpen(false)}>Services</a>
          </li>
          <li>
            <a href="#about" onClick={() => setOpen(false)}>About</a>
          </li>
          <li>
            <a href="#contact" onClick={() => setOpen(false)}>Contact</a>
          </li>
        </ul>

      </div>
    </nav>
  );
}

export default Navbar;
